/**
 * No of keys and name of keys should be same in both objects but value will be postfix with en and ar as per object type
 */

export const enKeys = {
  firstName: 'firstNameEn',
  lastName: 'lastNameEn',
  companyId: 'companyId',
  companyName: 'companyName',
  subUserType: 'subUserType',
  selected: 'selected',
  customerName: 'customerNameEn',
};

export const arKeys = {
  firstName: 'firstNameAr',
  lastName: 'lastNameAr',
  companyId: 'companyId',
  companyName: 'companyNameAr',
  subUserType: 'subUserType',
  selected: 'selected',
  customerName: 'customerNameAr',
};
